import { Swiper } from 'swiper';
import { A11y, Autoplay } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-logo-carousel .swiper');

if (sliders.length > 0) {
	const intialUrl = new URL(window.location);
	const backstop = intialUrl.searchParams.get('backstop');

	sliders.forEach((slider) => {
		const settings = {
			loop: true,
			spaceBetween: 16,
			slidesPerView: 2.4375,
			modules: [A11y, Autoplay],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			speed: 2000,
			autoplay: {
				delay: 0,
				enabled: true,
			},
			breakpoints: {
				448: {
					slidesPerView: 3,
				},
				576: {
					slidesPerView: 4,
					spaceBetween: 24,
				},
				768: {
					slidesPerView: 5,
					spaceBetween: 32,
				},
				992: {
					slidesPerView: 6,
					spaceBetween: 32,
				},
			},
		};

		if (backstop) {
			settings.autoplay = false;
		}

		new Swiper(slider, settings);
	});
}
